function moveProductElements() {
  const isMobile = $(window).width() < 600;

  const $tags = $('.product-info ul.tags');
  const $title = $('.product-info h1');
  const $gallery = $('.product-gallery');
  const $info = $('.product-info');
  const $cta = $('.cta-boxes-section'); // ✅ added

  if (isMobile) {

    if (!$gallery.prev().is($title)) {
      $tags.insertBefore($gallery);
      $title.insertBefore($gallery);
    }

    $cta.insertAfter($info);

  } else {

    if (!$info.find('ul.tags').length) {
      $tags.prependTo($info);
      $title.insertAfter($tags);
    }

    // (leave desktop behaviour untouched)

  }
}

$(document).ready(function () {
  moveProductElements();
});

$(window).on('resize', function () {
  moveProductElements();
});